import { Component, Input, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AuthService } from "../../../services/auth.service";
import { StreamingPolicyFieldType } from "../../../entities/device/definition.entity";
import { DeviceEntity } from "../../../entities/device.entity";
import { ToasterService } from "angular2-toaster";

@Component({
  selector: "embed-device-streaming-policy",
  template: `
    <div [ngSwitch]="layout">
      <div *ngSwitchCase="'card'">
        <div class="card border-info">
          <div class="card-header bg-info m-0 p-1">
            <div class="row">
              <div class="col-9">
                {{ options.title || "StreamingPolicy" }}
              </div>
              <div class="col-3 text-right">
                <i
                  (click)="streamingPolicyExpand = !streamingPolicyExpand"
                  class="fa fa-sm pr-2"
                  [ngClass]="{
                    'fa-chevron-down': !streamingPolicyExpand,
                    'fa-chevron-up': streamingPolicyExpand
                  }"
                >
                </i>
              </div>
              <div class="col-3 text-right">
                <i
                  (click)="streamingPolicyExpand = !streamingPolicyExpand"
                  class="fa fa-sm pr-2"
                  [ngClass]="{
                    'fa-chevron-down': !streamingPolicyExpand,
                    'fa-chevron-up': streamingPolicyExpand
                  }"
                >
                </i>
              </div>
            </div>
          </div>

          <div class="card-body m-0 p-1" *ngIf="streamingPolicyExpand">
            <div class="row">
              <div class="col-12">
                <embed-device-streaming-policy
                  [entity]="entity"
                  [layout]="'table'"
                  [options]="options"
                  [deviceAdmin]="deviceAdmin"
                ></embed-device-streaming-policy>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="'table'">
        <div>
          <div class="div-table-th">
            <div class="row" *ngIf="!options?.edit">
              <div class="col-5">Policy</div>
              <div class="col-5">Value</div>
              <button
                *ngIf="deviceAdmin"
                style="padding: 1px; margin-left: -20px;"
                class="col-2 btn btn-info"
                (click)="resetPolicy()"
              >
                Reset
              </button>
            </div>
            <div class="row" *ngIf="options?.edit">
              <div class="col-5">Policy</div>
              <div class="col-5">Value</div>
              <div class="col-2"><i class="fa fa-trash"></i></div>
            </div>
          </div>

          <div class="row" *ngIf="entity?.policyList.length === 0">
            <div class="col">
              <div class="alert-info">
                <widget-spinner></widget-spinner>
              </div>
            </div>
          </div>

          <div
            *ngFor="let pol of entity?.policyList; let i = index"
            [ngClass]="{
              'div-table-tr': i % 2 == 1,
              'div-table-tr-alt': i % 2 == 0
            }"
          >
            <div class="row align-items-center" *ngIf="!options?.edit">
              <div class="col-5 col-5">
                <b>{{ pol.key }}:</b>
              </div>
              <div class="col-5 col-5">
                <span>{{ pol.value }}</span>
              </div>
              <div
                (mouseover)="showStreamingPolicyToolTip($event, pol.key)"
                (mouseout)="hideTooltip()"
                class="col-2 col-2 text-end"
              >
                <i class="fa fa-info-circle"></i>
              </div>
            </div>

            <div class="row" *ngIf="options?.edit">
              <div class="col-5">
                <input
                  type="text"
                  [(ngModel)]="pol.key"
                  (change)="updatePolicy($event, pol)"
                  size="18"
                />
              </div>
              <div [ngSwitch]="pol.type" class="col-5">
                <span *ngSwitchDefault>
                  <input
                    type="text"
                    [(ngModel)]="pol.value"
                    (change)="updatePolicy($event, pol)"
                    size="18"
                  />
                </span>
              </div>
            </div>
          </div>

          <div
            *ngIf="options?.edit"
            [ngClass]="{
              'div-table-tr': entity?.policyList.length % 2 == 1,
              'div-table-tr-alt': entity?.policyList.length % 2 == 0
            }"
          ></div>
        </div>
      </div>

      <ng-template #policyModal>
        <div class="modal-header">
          <h4 class="modal-title pull-left">{{ currentModal?.title }}</h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="policyModalRef.hide()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <widget-spinner *ngIf="currentModal?.processing"></widget-spinner>
          <div class="row" *ngIf="!currentModal?.processing">
            <span>
              <div class="col-5">
                <input type="text" [(ngModel)]="newPolicy.key" size="18" />
              </div>
            </span>
            <span>
              <div class="col-5">
                <input type="text" [(ngModel)]="newPolicy.value" size="18" />
              </div>
            </span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            *ngIf="currentModal?.cancelMsg"
            type="button"
            class="btn btn-secondary"
            (click)="currentModal?.cancel()"
            data-dismiss="modal"
          >
            {{ currentModal?.cancelMsg }}
          </button>
          <button
            *ngIf="currentModal?.deleteMsg"
            type="button"
            class="btn btn-warning"
            (click)="currentModal?.delete()"
            data-dismiss="modal"
          >
            {{ currentModal?.deleteMsg }}
          </button>
          <button
            *ngIf="currentModal?.confirmMsg"
            type="button"
            class="btn btn-danger"
            (click)="currentModal?.confirm()"
          >
            {{ currentModal?.confirmMsg }}
          </button>
        </div>
      </ng-template>
    </div>
    <div
      *ngIf="tooltipVisible"
      class="absolute z-50 p-4 bg-white border border-gray-300 rounded-lg shadow-md w-64 text-sm tooltip-fade-in"
      [ngStyle]="{ top: tooltipY + 'px', left: tooltipX + 'px' }"
      (mouseleave)="hideTooltip()"
    >
      <h6 class="fw-semibold mb-2 text-primary">{{ tooltipData?.jsonName }}</h6>
      <p class="mb-1">
        <strong>Description:</strong>
        <span>{{ tooltipData?.description }}</span>
      </p>
      <p class="mb-1">
        <strong>Default:</strong>
        <span class="badge bg-light text-dark border">{{
          tooltipData?.default
        }}</span>
      </p>
      <p class="mb-0">
        <strong>Range:</strong>
        <span>{{ tooltipData?.valueRange }}</span>
      </p>
      <p class="mb-0">
        <strong>Default Variables:</strong>
        <span>{{ tooltipData?.defaultVariables }}</span>
      </p>
    </div>
  `,
})
export class EmbedStreamingPolicyComponent implements OnInit {
  @Input() entity: DeviceEntity = null;
  @Input() options: any = null;
  @Input() layout: string = null;
  @Input() deviceAdmin: boolean = false;
  public newPolicy = { key: "new", value: 0 };
  public policyFieldTypes = StreamingPolicyFieldType;
  public policyModalRef: BsModalRef;
  public currentModal: any;
  public isDevice = false;
  public streamingPolicyExpand = false;
  public policyArray: { key: string; value: any }[] = [];
  public streamingPolicyTooltipData = [
    {
      jsonName: "web_debug_level",
      valueRange:
        "0 : NONE, 1 : BASIC INFO, 2 : ADVANCED INFO, 3 : STATISTICS , 4 : SETTINGS, 5 : ADMIN EDIT, 6 : ADMIN OTA",
      default: 1,
      description:
        "Controls which web pages are visible and if server or user can control SP & OP settings",
    },
    {
      jsonName: "sp_op_size",
      valueRange: "1…100",
      default: 25,
      description: "Maximum no. of entries (sensors) in SP & OP tables",
    },
    {
      jsonName: "sp_level",
      valueRange: "0 : disabled, 1 : enabled",
      default: 1,
      description: `SP is enabled/disabled:
  Enabled: SP filters some binary values coming from MCU according to SP settings
  Disabled: Binary values from MCU are handled like in version V3.`,
    },
    {
      jsonName: "op_level",
      valueRange: "0 : disabled, 1 : enabled",
      default: 1,
      description: `OP is enabled/disabled:
  Enabled: Outliers are removed
  Disabled: No Outlier detection like in version V3
  Note: OP is part of SP. If SP is disabled, OP will not work.`,
    },
    {
      jsonName: "relay_level",
      valueRange: "0 : disabled, 1 : enabled",
      default: 0,
      description: `Sensor Blocker mode enabled/disabled:
  Enabled: External sensors are blocked.
  Disabled: External sensors are sent to server like in version V3.`,
    },
    {
      jsonName: "wakeup_level",
      valueRange: "0 : off, 1 : on",
      default: 0,
      description: `Wake Up calls on/off:
  On: All wake up calls sent to server like in version V3
  Off: Requests only sent after power on or every 20th. request`,
    },
    {
      jsonName: "diagnostics_level",
      valueRange: "0 : off, 1 : on",
      default: 0,
      description: `Gateway extra diagnostics sending on/off:
  On: Send gateway diagnostics data in all the report_binary request.
  Off: Data will be only available in gateway internal report_binary.`,
    },
    {
      jsonName: "lapi_level",
      valueRange: "0…100, 0 = off",
      default: 0,
      description: `Controls the Local API, which gives local access to the measurement data within the ESP32:
  0: Off. Local API is unavailable, no local access to measurement values.
  >0: Maximum size of the Local API table, i.e. the maximum number of sensors / Data IDs included in the table.
  Initially enabled only for the XE100; on other stations it is for testing, development or debugging only.`,
      defaultVariables: "XE100: 100, all other stations (X100, V11, etc.): 0",
    },
    {
      jsonName: "hb_level",
      valueRange: "0…1440, 0= never, 1= 1 minute, etc.",
      default: 27,
      description: `Controls frequency in minutes of a spoofed (not triggered by DU MCU) wake call. Timer resets with any other call (bin, wake, etc) sent by the Gateway.
                    defaultVariables: WS with Internal Sensors- 0
                                      Gateway Only Models- 27`,
    },
    {
      jsonName: "storage_level",
      valueRange: "0 : off, 1 : on",
      default: 0,
      description: `Controls if the Gateway will write the diagnostic data to flash memory block with each bin call. It is set to Off by default to reduce memory block failure over time.
On: New diagnostic data will be stored to memory each time sent.
Off: New diagnostic data not saved every time.`,
    },
  ];

  constructor(
    public modalService: BsModalService,
    public authService: AuthService,
    public toasterService: ToasterService
  ) {}

  ngOnInit() {
    this.isDevice = this.entity instanceof DeviceEntity;
  }

  public tooltipData: any = null;
  public tooltipVisible = false;
  public tooltipX = 0;
  public tooltipY = 0;

  public showStreamingPolicyToolTip(e, key) {
    e.preventDefault();
    const data = this.streamingPolicyTooltipData.filter(
      (item) => item.jsonName == key
    )[0];
    if (data) {
      this.tooltipData = data;
      this.tooltipVisible = true;
      this.tooltipX = e.clientX;
      this.tooltipY = e.clientY;
    }
  }
  public hideTooltip() {
    this.tooltipVisible = false;
  }

  public updatePolicy(e, p) {
    p.value = Number(p.value);
    this.entity.updatePolicy(p);
  }
  public resetPolicy() {
    this.entity.pending = true;
    this.toasterService.pop(
      "info",
      "Streaming Policy Reset",
      `Streaming policy reset in progress.`
    );
    this.entity.putResetPolicy().then((result: any) => {
      if (result.success) {
        this.toasterService.pop(
          "info",
          "Streaming Policy Reset",
          `Streaming policy reset successfully.`
        );
      } else {
        this.toasterService.pop(
          "info",
          "Streaming Policy Reset Failed",
          result.error.details.error.msg
        );
      }
      this.entity.pending = false;
    });
  }
}
